import styled from 'styled-components';

export const Container = styled.tfoot`
  td {
    padding: 0;
    border: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: stretch;
  margin: 12px 0 6px;
  @media (${props => props.theme.breakpoint.sm.up}) {
    margin: 10px 0 0;
  }
`;
